import { GuestsNightsLabel } from '@app/components/atoms/guests-nights-label';
import { Price } from '@app/components/molecules/price';
import { apiTypes } from '@app/models';
import { Currency } from '@app/models/api/api-types';
import { checkoutDetailsSlice, useAppSelector } from '@app/state';

import { ReservationPriceProps } from './reservation-price.props';

export const ReservationPrice = ({
    currency,
    totalPrice,
    convertedRatesCurrency,
    basePrice,
    convertedBasePrice,
    convertedTotalPrice,
    guests,
    childrenAges,
    nightsCount,
    priceWrapperProps,
    ...rest
}: ReservationPriceProps) => {
    const checkoutDiscounts = useAppSelector(
        checkoutDetailsSlice.selectors.selectCheckoutDiscounts,
    );

    return (
        <Price
            currency={currency ?? Currency.Pln}
            price={totalPrice ?? 0}
            basePrice={basePrice ?? 0}
            discounts={(checkoutDiscounts as apiTypes.Discount[]) ?? undefined}
            convertedCurrency={convertedRatesCurrency}
            convertedPrice={convertedTotalPrice}
            convertedBasePrice={convertedBasePrice}
            priceWrapperProps={priceWrapperProps}
            {...rest}
        >
            <GuestsNightsLabel
                adultsCount={guests ?? 0}
                childrenCount={childrenAges?.length ?? 0}
                nightsCount={nightsCount}
            />
        </Price>
    );
};
